module.exports = __webpack_public_path__ + "img/check-up-campaign.748cc590.jpg";